module.exports = __webpack_public_path__ + "assets/fonts/GothamPro-MediumItalic.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamPro-MediumItalic.woff
// module id = 1907
// module chunks = 0